import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvatarModule } from 'src/app/ui/components/avatar/avatar.module';

import { SegmentedNavigationModule } from '../../components/segmented-navigation/segmented-navigation.module';
import { QuestionsService } from '../questions/questions.service';
import { AccountComponent } from './account.component';
import { AccountRoutingModule } from './account-routing.module';

@NgModule({
  declarations: [AccountComponent],
  imports: [
    CommonModule,
    SegmentedNavigationModule,
    AccountRoutingModule,
    AvatarModule,
  ],
  providers: [QuestionsService],
})
export class AccountModule {}
